import "./MainModule.scss";

export const MainModule = () => {
  return <div className="main-module"></div>;
};
